// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#product-description-container .course-description__readmore__dropdown {\n  padding-bottom: 22px;\n  font-weight: 300;\n  line-height: 2;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
